import React from "react";
import { Icon } from '../../facades';
import { Prefix } from '../../facades/Icon';

export interface CloseButton {
    size?: "sm" | "md" | "lg",
    iconStyle?: "solid" | "regular" | "light" | "duotone",
    className?: string,
    textColor?: string,
    onClick: () => void
}

const iconStyles = {
  "solid": 'fas' as Prefix,
  "regular": 'far' as Prefix,
  "light": 'fal' as Prefix,
  "duotone": 'fad' as Prefix
}

const sizeMap = {
  sm: 16,
  md: 24,
  lg: 32,
};

export const CloseButton = ({ onClick, className = "", textColor = "text-dark", size = "md", iconStyle ="light" } : CloseButton) => {
  const pxSize = sizeMap[size];
  return (
    <button className={`${className} ${textColor} btn btn-link`} onClick={onClick} >
      <Icon style={{fontSize: pxSize}} icon='times' lib={iconStyles[iconStyle]}/>
    </button>
  );
};

export default CloseButton;
